import axios from "axios"

export const getAssociatedPanelMembers = async(id) => {
    try {
        const res = await axios.get(`/api/Company/getAllMember?panelId=${id}`);
        return res;
    } catch (error) {
        console.log('err fetching panel members', error.message);       
    }
}